import type { Cb2PreviewScenarioPayload } from './cb2-preview-protocol';

/**
 * Reads authoritative scenario content from `payload.data`.
 * No local fixture fallback — missing data yields null.
 */
export function previewScenarioData<T>(
  payload: Cb2PreviewScenarioPayload | null | undefined,
  blocType: string,
): T | null {
  if (!payload || payload.blocType !== blocType) {
    return null;
  }
  if (payload.data && typeof payload.data === 'object') {
    return payload.data as T;
  }
  return null;
}
